import { Route, Switch, Redirect } from 'react-router-dom';
import Login from './views/auth/login/login';
import { Container, Row } from 'shards-react';
import Header from './views/auth/Header/Header';
import PasswordRecovery from './views/auth/password-recovery/password-recovery';
import ResetPassword from './views/auth/reset-password/reset-password';

const AuthRoutes = () => {
  return (
    <Container fluid>
      <Row>
        <Header />
        <Switch>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/password-recovery">
            <PasswordRecovery />
          </Route>
          <Route path="/reset-password">
            <ResetPassword />
          </Route>
          <Route exact path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      </Row>
    </Container>
  );
};

export default AuthRoutes;
